import React from "react";
import Book from "../../components/Book/Book";
import classes from "./AboutPage.css";

import MoeImage from "../../assets/images/moe-2024.jpg";

const aboutpage = (props) => (
    <div className={classes.AboutPage}>
        <div className={classes.title}>
            <span>THE SHOP</span>
        </div>
        <div className={classes.window}>
            <p>
                At Moe’s Barber shop we strive to provide genuine advice and
                service. Every head of hair is treated with the utmost respect
                and styled to perfection with wallet-friendly competitive
                prices.
            </p>
            <p>
                Moe has created a little piece of Eden Park history inside his
                sports-themed barber shop with original Eden Park signage, and
                memorabilia from the sporting world.
            </p>
            <p>
                It’s a place where dads can bring their sons, where mates can
                meet up and chat, catch up on the latest sports news, have a
                laugh and walk out feeling and looking your best!
            </p>
        </div>
        <div className={classes.title}>
            <span>MOE</span>
        </div>

        <img src={MoeImage} alt="Moe styling hair" />

        <div className={classes.window}>
            <p>
                At 19, Moe went to the Premier Hairdressing College, then
                finished off his apprenticeship at Rodney Wayne 277. He
                continued to style hair and polish his skills in Newmarket at
                different salons.
            </p>
            <p>
                After 10 years’ hairdressing Moe changed tack. He has travelled
                the world working on superyachts, owned award-winning
                nightclubs, worked behind the scenes in television and on
                academy award-winning films, tried his hand at property
                development, and recently worked in the real estate industry.
            </p>
            <p>
                But with a return to grassroots barbering, Moe and his team are
                set to make your experience at Moe’s Barber shop a gamechanger!
            </p>
        </div>
        <Book />
    </div>
);

export default aboutpage;



// WEBPACK FOOTER //
// ./src/containers/AboutPage/AboutPage.js